import create from 'zustand';
import { config } from '../../utils/config';

const initialState = {
  token: config.token(),
  loginState: !!config.token(), // Check if the token exists
};

// Define your Zustand store
export const useAuthStore = create((set) => ({
  token: initialState.token,
  loginState: initialState.loginState,

  // Method to check login status
  checkLogin: () =>
    set(() => {
      const token = config.token();
      const isLoggedIn = !!token;
      return { token, loginState: isLoggedIn };
    }),

  setToken: (newToken) =>
    set(() => {
      return { token: newToken, loginState: !!newToken };
    }),

  // Initialize store
  initialize: () =>
    set(() => {
      const token = config.token();
      const isLoggedIn = !!token;
      return { token, loginState: isLoggedIn };
    }),
}));
